var Vendd = (function (Vendd) {
	'use strict';

    var pending = false;
    var logoutRedirectUrl = '';

	var getVisitorState = function getVisitorState() {

        var cookie = Cookies.get("VisitorState");

		var options = {
			url: 'CmsService.svc/InitVisitorState',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		if (cookie) {
			return cookie;
		} else {
			Vendd.Service.Call(options);
		};

		function onSuccess(response) {
            cookie = Cookies.get("VisitorState");

			if (response.success && cookie) {
				return cookie;
			};
		};

		function onFailure(response) {
			console.log(response);
		};
	};

	var setVisitorState = function setVisitorState(cookie) {

		if (cookie) {

			var oldUrl = window.location.href;
			var cookieValueAsUrl = "?" + cookieValue;

		}
	};

	Vendd.User.AuthProviders = (function (AuthProviders) {
		return AuthProviders;
	})(Vendd.User.AuthProviders || {});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.SsoLogin, Vendd.User, function (envelope) {
		Vendd.User.ClearClientModel();

		document.location.href = '/VenddSso/StartLogin';
	});

    Vendd.MessageBus.subscribe(Vendd.User.Messages.SsoRegister, Vendd.User, function (envelope) {
        Vendd.User.ClearClientModel();

        document.location.href = '/VenddSso/StartRegistration';
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.Login, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/Login',
			data: {
				loginName: envelope.message.data.loginName,
				password: envelope.message.data.password,
				rememberMe: envelope.message.data.rememberMe,
				reCaptchaCode: envelope.message.data.reCaptchaCode,
				accessToken: envelope.message.data.accessToken
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

        function onSuccess(response) {
            if (response.success) {

                response.loginName = envelope.message.data.loginName;
                response.password = envelope.message.data.password;

                Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginSuccess(response));

                //one call here after login and one call in check user session
                Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModel());
            }
            else {
                Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginFailure(response));
            }
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginFailure(response));
		};

        Vendd.User.ClearClientModel();

		Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, Vendd.User, function (envelope) {
        var model = envelope && envelope.message && envelope.message.data && envelope.message.data.model;
        if (model) {
			model = model ? $.extend({}, model, { LangCode: LhApp.Context.Language, CurrCode: LhApp.Context.Currency.Code }) : model;
            logoutRedirectUrl = model.LoginForm.LogoutRedirectUrl;
        }

        Vendd.User.SetClientModel(model);
    });

	Vendd.MessageBus.subscribe(Vendd.User.Messages.ForgotPassword, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/ForgotPassword',
			data: envelope.message.data.email,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ForgotPasswordSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ForgotPasswordFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.ResetPassword, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/ResetPassword',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ResetPasswordSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ResetPasswordFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.ResendActivationCode, Vendd.User, function (envelope) {

		var options = {
			url: 'api/Account/ResetPasswordForPendingCustomer',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ResendActivationCodeSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.ResendActivationCodeFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.Logout, Vendd.User, function (envelope) {

		Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutAuthProviders());

	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutAuthProviders, Vendd.User, function (envelope) {

		var logoutPromises = [];

		Object.keys(Vendd.User.AuthProviders).forEach(function (provider) { 
			if (typeof (Vendd.User.AuthProviders[provider].logout) === 'function' && Vendd.User.AuthProviders[provider].initiated) {

				var promise = $.Deferred(function (defer) {
					Vendd.User.AuthProviders[provider].logout(function () {
						defer.resolve();
						return defer.promise();
					});
				});

				logoutPromises.push(promise);
			}
		});

		$.when.apply($, logoutPromises).then(function () {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutUser());
		});

	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutUser, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/Logout',
			data: {},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
            if (response.success) {
                Cookies.set("ForceClearCartLocalStorage", 1, { samesite: 'Lax' });
                Cookies.set("ForceClearCompareLocalStorage", 1, { samesite: 'Lax' });
				Cookies.set("ForceClearWishlistLocalStorage", 1, { samesite: 'Lax' });

				if (LhApp.Context.MultipleWishlistsEnabled)
				    Vendd.UserWishlist.ClearClientModel();

				var redirectUrl = logoutRedirectUrl || (document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/');

				if (logoutRedirectUrl.length < 1 && document.location.href.indexOf('/' + LhApp.Context.Language + '/') > -1) {
					redirectUrl = redirectUrl + LhApp.Context.Language + '/';
				}

				if (LhApp.Context.SsoEnabled) {
					document.location = '/VenddSso/LogoutSso' + '?redirectUrl=' + redirectUrl;
				} else {
					if (redirectUrl === document.location.pathname) {
						Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutSuccess(response));
					} else {
						document.location = redirectUrl;
					}
				}
            }

		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LogoutFailure(response));
		};

        Vendd.User.ClearClientModel();

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.Register, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/Register',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {

			if (!response.success) return onFailure(response);

			if (response.success && response.code === "Registration_OperationSuccesful") {
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.RegisterSuccess(response));
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginRedirect(envelope));
			}
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.RegisterFailure(response));
		};

		Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.User.Messages.CompleteSsoRegistration, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/CompleteSsoRegistration',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {

			if (!response.success) return onFailure(response);

			if (response.success && response.code === "Registration_OperationSuccesful") {
				var responseCopy = Object.assign({}, response);

				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.RegisterSuccess(response));
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginSuccess(responseCopy));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.RegisterFailure(response));
		}

		Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.CanRegister, Vendd.User, function (envelope) {

        var options = {
            url: 'AuthService.svc/CanRegister',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {

            if (!response.success) return onFailure(response);

            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CanRegisterSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CanRegisterFailure(response));
        };

        Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegister, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/B2BRegister',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.B2BRegisterSuccess(response));
			if (response.success && response.code === "Registration_OperationSuccesful" && response.data.login) {
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.LoginRedirect(envelope));
			}
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.B2BRegisterFailure(response));
		};

		Vendd.Service.call(options);
	});

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetAreasForPostCode, Vendd.User, function (envelope) {

        var options = {
            url: 'AccountService.svc/AreaLookUp',
            data: {
                countryCode: envelope.message.data.countryCode,
                postalCode: envelope.message.data.postalCode,
                selectedAreaCode: envelope.message.data.selectedAreaCode
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetAreasForPostCodeSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetAreasForPostCodeFailure(response));
        };

        Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.User.Messages.CreateUser, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/CreateUser',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CreateUserSuccess(response));
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.CreateUserFailure(response));
		};

		Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModel, Vendd.User, function (envelope) {

        if (pending === true) {
            return false;
        };

        var model = Vendd.User.GetClientModel();

        var useModelFromLocalStorage = model && document.cookie.indexOf('ForceClearUserLocalStorage') === -1;
        if (model && !model.hasOwnProperty("RegisterForm")) //VENDDTHREE-2419: structural change of model we expect this property filled || null
            useModelFromLocalStorage = false;

        if (useModelFromLocalStorage) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModelSuccess(model));
            return true;
        }

        var options = {
            url: 'UserService.svc/GetUserViewModel' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
            data: { templateCode: LhApp.Context.Item ? LhApp.Context.Item.Template : "" },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		function onSuccess(response) {
			model = response ? $.extend({}, response, { LangCode: LhApp.Context.Language, CurrCode: LhApp.Context.Currency.Code }) : response;
		    Vendd.User.SetClientModel(model);

            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModelSuccess(response));
			pending = false;
		};

		function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModelFailed(response));

            pending = false;
		};

        Cookies.remove('ForceClearUserLocalStorage', { path: '/' });
		pending = true;

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.GetCountrySelector, Vendd.User, function () {
        var options = {
			url: 'UserService.svc/GetCountrySelector',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetCountrySelectorSuccess(response));

            pending = false;
        };

        function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetCountrySelectorFailed(response));

            pending = false;
        };

        Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.User.Messages.QuoteSubmit, Vendd.User, function (envelope) {

		var options = {
			url: 'AuthService.svc/QuoteSubmit',
			data: {
				email: envelope.message.data.email,
				userName: envelope.message.data.userName,
				message: envelope.message.data.message,
				skuId: envelope.message.data.skuId
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.QuoteSubmitSuccess(response));
			}
		};

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.QuoteSubmitFailure(response));
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginRedirect, Vendd.User, function (envelope) {

		var loginName = envelope.message.data.loginName || envelope.message.data.email || envelope.message.data.username;

		var redirectUrl = envelope.message.data.redirectUrl;

		/*if redirect is not defined reload page */
		if (!redirectUrl) {
			redirectUrl = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/';
		}

		var loginmessage = new Vendd.User.Messages.Login(loginName, envelope.message.data.password, envelope.message.data.rememberMe, redirectUrl);
		Vendd.MessageBus.publishAsync(Vendd.User, loginmessage);
	});

    Vendd.User.ClearClientModel = function () {
        localStorage.removeItem('CurrentUserModel');
    };

    Vendd.User.GetClientModel = function () {
        var mdl = JSON.parse(localStorage.getItem("CurrentUserModel"));

        return LhApp.Function.validateClientModel(mdl)
            ? $.extend({ IsLocalStorageCache: true }, mdl)
            : null;
    };

    Vendd.User.SetClientModel = function (mdl) {
        localStorage.setItem('CurrentUserModel', JSON.stringify(mdl));
	};

	Vendd.MessageBus.subscribe(Vendd.User.Messages.GetMemberByLoyaltyNumber, Vendd.User, function (envelope) {
		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetMemberByLoyaltyNumberSuccess(response));
		}
		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetMemberByLoyaltyNumberFailed(response));
		}

		var options = {
			url: 'api/LoyaltyPoints/GetMemberByLoyaltyNumber?siteCode=' + LhApp.Context.Site.Code + '&loyaltyNumber=' + envelope.message.data.loyaltyMemberCardNumber,
			method: 'GET',
			onSuccess: onSuccess,
			onFailure: onFailure
		};
		Vendd.Service.call(options);
	});

	//this should be moved to every component that requires this component's data. e.g. login widget AND in case your page DOES NOT contain that widget then you have to make sure theres somewhere this call 
	(function () {
		var defaultCallExecuted;
		function defaultCall() {
			if (Vendd.User.SessionState && !defaultCallExecuted) {
				defaultCallExecuted = true;

				if (Vendd.User.SessionState.IsNewSession)
					Vendd.User.ClearClientModel();

				if (venddProjectConfigs.UserModelEnabled) {
					//one call here and one call after login
					Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModel());
				}
			}
		}
		defaultCall();
		Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, Vendd.User, function (envelope) {
			defaultCall();
		});
	})();

	return Vendd;

})(Vendd || {});



function onSignIn(googleUser) {
	var profile = googleUser.getBasicProfile();
	var id_token = googleUser.getAuthResponse().id_token;
};
